import createIcon from '../../createIcon';

/**
 * @component @name Roofing
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMgMTguNUgxMVYxNi41SDEzVjE4LjVaTTE1IDE0LjVIOVYyMC41SDE1VjE0LjVaTTE5IDkuOFY0LjVIMTZWNy4xTDEyIDMuNUwyIDEyLjVINUwxMiA2LjE5TDE5IDEyLjVIMjJMMTkgOS44WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Roofing = createIcon('Roofing', [
  [
    'path',
    {
      d: 'M13 18.5H11V16.5H13V18.5ZM15 14.5H9V20.5H15V14.5ZM19 9.8V4.5H16V7.1L12 3.5L2 12.5H5L12 6.19L19 12.5H22L19 9.8Z',
      key: 'f72o3g',
    },
  ],
]);

export default Roofing;
